import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { AccessibilityProvider } from "./context/AccessibilityContext";
import useVisitTracker from "./hooks/useVisitTracker";
import CvdFilters from "./components/CvdFilters";
import AccessibilityToolbar from "./components/AccessibilityToolbar";
import Home from "./pages/Home";
import Projects from "./pages/Projects";
import Certificates from "./pages/Certificates";
import Gallery from "./pages/Gallery";
import CV from "./pages/CV";
import ProjectExtablify from "./pages/projects/ProjectExtablify";
import ProjectKasa from "./pages/projects/ProjectKasa";
import ProjectResumeArchitecture from "./pages/projects/ProjectResumeArchitecture";
import ProjectCommunityHealthAmbassadors from "./pages/projects/ProjectCommunityHealthAmbassadors";
import ProjectVolunteerActivities from "./pages/projects/ProjectVolunteerActivities";
import ProjectAutismSexEducation from "./pages/projects/ProjectAutismSexEducation";

/** Scrolls to the top of the page on every route change (except hash links,
 *  which Home.jsx handles itself by scrolling to the target section). */
function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

/** Pings the track-visit function on every route change. See useVisitTracker. */
function VisitTracker() {
  useVisitTracker();
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <AccessibilityProvider>
        <ScrollToTop />
        <VisitTracker />
        <CvdFilters />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/extablify" element={<ProjectExtablify />} />
          <Route path="/projects/kasa" element={<ProjectKasa />} />
          <Route path="/projects/resume-architecture" element={<ProjectResumeArchitecture />} />
          <Route path="/projects/community-health-ambassadors" element={<ProjectCommunityHealthAmbassadors />} />
          <Route path="/projects/volunteer-activities" element={<ProjectVolunteerActivities />} />
          <Route path="/projects/autism-sex-education" element={<ProjectAutismSexEducation />} />
          <Route path="/certificates" element={<Certificates />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/cv" element={<CV />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <AccessibilityToolbar />
      </AccessibilityProvider>
    </BrowserRouter>
  );
}
